/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description articleArticleIdClassifyUsingGet参数
 * @property `articleId` 文章id
 */
export interface ParamsarticleArticleIdClassifyUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * @description articleArticleIdOthersUsingGet参数
 * @property `articleId` 文章id
 */
export interface ParamsarticleArticleIdOthersUsingGet {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * @description articleArticleIdUploadImgUsingPost参数
 * @property `articleId` 文章id
 */
export interface ParamsarticleArticleIdUploadImgUsingPost {
  // pathParams
  /**
   * 文章id
   */
  articleId: number;
}
/**
 * 图片链接
 */
export type ParamsBodyarticleArticleIdUploadImgUsingPost = string;
/**
 * @description articleArticleIdUsingDelete参数
 * @property `articleId` 删除的文章id
 * @property `[articleStatus]` 该文章状态 来源后端 PUBLSHED/DRAFT/PUBLISHED_EDIT
 */
export interface ParamsarticleArticleIdUsingDelete {
  // pathParams
  /**
   * 删除的文章id
   */
  articleId: number;
  // queryParams
  /**
   * 该文章状态 来源后端 PUBLSHED/DRAFT/PUBLISHED_EDIT
   */
  articleStatus?: string;
}
/**
 * userGetAtInfo
 */
export type ParamsBodyarticleAtUsingPut = models.UserGetAtInfo;
/**
 * @description articleChooseUsingGet参数
 * @property `[keywords]` keywords
 */
export interface ParamsarticleChooseUsingGet {
  // queryParams
  /**
   * keywords
   */
  keywords?: string;
}
/**
 * @description articleIdUsingGet参数
 * @property `id` id
 * @property `articleStatus` DRAFT为草稿状态 PUBLISHED为已发布状态 PUBLISHED_EDIT为已发布再编辑状态
 */
export interface ParamsarticleIdUsingGet {
  // pathParams
  /**
   * id
   */
  id: number;
  // queryParams
  /**
   * DRAFT为草稿状态 PUBLISHED为已发布状态 PUBLISHED_EDIT为已发布再编辑状态
   */
  articleStatus: string;
}
/**
 * @description articleInterestBussinessIdUsingPost参数
 * @property `bussinessId` 文章bussinessId
 */
export interface ParamsarticleInterestBussinessIdUsingPost {
  // pathParams
  /**
   * 文章bussinessId
   */
  bussinessId: string;
}
/**
 * @description articleNewBusinessIdUsingDelete参数
 * @property `businessId` 删除的文章businessId
 * @property `[type]` 删除类型(1:草稿，2:文章)
 */
export interface ParamsarticleNewBusinessIdUsingDelete {
  // pathParams
  /**
   * 删除的文章businessId
   */
  businessId: string;
  // queryParams
  /**
   * 删除类型(1:草稿，2:文章)
   */
  type?: number;
}
/**
 * @description articleNewBusinessIdUsingGet参数
 * @property `businessId` businessId
 */
export interface ParamsarticleNewBusinessIdUsingGet {
  // pathParams
  /**
   * businessId
   */
  businessId: string;
}
/**
 * @description articlePartIdUsingGet参数
 * @property `id` id
 * @property `articleStatus` DRAFT为草稿状态 PUBLISHED为已发布状态 PUBLISHED_EDIT为已发布再编辑状态
 */
export interface ParamsarticlePartIdUsingGet {
  // pathParams
  /**
   * id
   */
  id: number;
  // queryParams
  /**
   * DRAFT为草稿状态 PUBLISHED为已发布状态 PUBLISHED_EDIT为已发布再编辑状态
   */
  articleStatus: string;
}
/**
 * @description articlePartNewBusinessIdUsingGet参数
 * @property `businessId` id
 */
export interface ParamsarticlePartNewBusinessIdUsingGet {
  // pathParams
  /**
   * id
   */
  businessId: string;
}
/**
 * @description articlePublishNewUsingPut参数
 * @property `sendNotice` 是否发送消息到Kim群
 */
export interface ParamsarticlePublishNewUsingPut {
  // queryParams
  /**
   * 是否发送消息到Kim群
   */
  sendNotice: boolean;
}
/**
 * articleVO
 */
export type ParamsBodyarticlePublishNewUsingPut = models.ArticleVo;
/**
 * articleVO
 */
export type ParamsBodyarticlePublishUsingPut = models.ArticleVo;
/**
 * @description articleRevertIdUsingGet参数
 * @property `id` id
 */
export interface ParamsarticleRevertIdUsingGet {
  // pathParams
  /**
   * id
   */
  id: number;
}
/**
 * @description articleRevertNewBusinessIdUsingGet参数
 * @property `businessId` businessId
 */
export interface ParamsarticleRevertNewBusinessIdUsingGet {
  // pathParams
  /**
   * businessId
   */
  businessId: string;
}
/**
 * articleVO
 */
export type ParamsBodyarticleSaveNewUsingPut = models.ArticleVo;
/**
 * articleVO
 */
export type ParamsBodyarticleSaveUsingPut = models.ArticleVo;
/**
 * @description articleSelectGroupOrTeamUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsarticleSelectGroupOrTeamUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
/**
 * @description articleTagsUsingGet参数
 * @property `[keywords]` keywords
 */
export interface ParamsarticleTagsUsingGet {
  // queryParams
  /**
   * keywords
   */
  keywords?: string;
}
export class ArticleApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 获取文章分类列表
   * @param params ParamsarticleArticleIdClassifyUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListSimpleClassifyInfo
   */
  public articleArticleIdClassifyUsingGet = (
    params: ParamsarticleArticleIdClassifyUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListSimpleClassifyInfo> => {
    const path = '/api/article/{articleId}/classify';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 作者的其他文章
   * @param params ParamsarticleArticleIdOthersUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListArticleSimpleInfo
   */
  public articleArticleIdOthersUsingGet = (
    params: ParamsarticleArticleIdOthersUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListArticleSimpleInfo> => {
    const path = '/api/article/{articleId}/others';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 上传文章封面缩略图
   * @param params ParamsarticleArticleIdUploadImgUsingPost
   * @param data: ParamsBodyarticleArticleIdUploadImgUsingPost// 图片链接
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleArticleIdUploadImgUsingPost = (
    params: ParamsarticleArticleIdUploadImgUsingPost,
    data: ParamsBodyarticleArticleIdUploadImgUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/article/{articleId}/upload-img';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.articleId, 'articleId');
    p.data = data;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 删除文章的接口，返回删除的tab下删除后的有效文章数量
   * @param params ParamsarticleArticleIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public articleArticleIdUsingDelete = (
    params: ParamsarticleArticleIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/article/{articleId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('articleStatus' in params) p.query.articleStatus = params.articleStatus;
    ajax.check(params.articleId, 'articleId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 在文章中的艾特的接口，用于文章范围内的通知后端谁被艾特或者被取消艾特
   
   * @param data: ParamsBodyarticleAtUsingPut// userGetAtInfo
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleAtUsingPut = (
    data: ParamsBodyarticleAtUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/article/at';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.userGetAtInfo');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 使用keywords过滤当前用户所有已加入的圈子和团队 用于文章发布时选择团队和圈子
   * @param params ParamsarticleChooseUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleChooseUsingGet = (
    params: ParamsarticleChooseUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/article/choose';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keywords' in params) p.query.keywords = params.keywords;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 是保存文章的接口
   
   
   * @param opt ajax config
   * @returns {}
   */
  public articleDraftTransferUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/article/draft/transfer';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 每周热门前五
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleHotArticleUsingGet = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/article/hotArticle';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章详情的所有内容 是top与bottom的结合
   * @param params ParamsarticleIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleTotalVO
   */
  public articleIdUsingGet = (
    params: ParamsarticleIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleTotalVO> => {
    const path = '/api/article/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('articleStatus' in params) p.query.articleStatus = params.articleStatus;
    ajax.check(params.articleStatus, 'articleStatus');
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 想看
   * @param params ParamsarticleInterestBussinessIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public articleInterestBussinessIdUsingPost = (
    params: ParamsarticleInterestBussinessIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/article/interest/{bussinessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.bussinessId, 'bussinessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 根据articleBusinessId删除文章的接口，返回删除的tab下删除后的有效文章数量
   * @param params ParamsarticleNewBusinessIdUsingDelete
   
   * @param opt ajax config
   * @returns models.CommonResultint
   */
  public articleNewBusinessIdUsingDelete = (
    params: ParamsarticleNewBusinessIdUsingDelete,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultint> => {
    const path = '/api/article/new/{businessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('type' in params) p.query.type = params.type;
    ajax.check(params.businessId, 'businessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'DELETE',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章详情的所有内容 是top与bottom的结合
   * @param params ParamsarticleNewBusinessIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleTotalVO
   */
  public articleNewBusinessIdUsingGet = (
    params: ParamsarticleNewBusinessIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleTotalVO> => {
    const path = '/api/article/new/{businessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.businessId, 'businessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章详情的上半部分内容 文章的详情 包括文章内容 标记 作者 不包含点赞评论和团队或圈子信息 编辑文章页面的调用
   * @param params ParamsarticlePartIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articlePartIdUsingGet = (
    params: ParamsarticlePartIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/part/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('articleStatus' in params) p.query.articleStatus = params.articleStatus;
    ajax.check(params.articleStatus, 'articleStatus');
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取文章详情的上半部分内容 文章的详情 包括文章内容 标记 作者 不包含点赞评论和团队或圈子信息 编辑文章页面的调用
   * @param params ParamsarticlePartNewBusinessIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articlePartNewBusinessIdUsingGet = (
    params: ParamsarticlePartNewBusinessIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/part-new/{businessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.businessId, 'businessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   *
   * @summary 发布文章的接口
   * @param params ParamsarticlePublishNewUsingPut
   * @param data: ParamsBodyarticlePublishNewUsingPut// articleVO
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articlePublishNewUsingPut = (
    params: ParamsarticlePublishNewUsingPut,
    data: ParamsBodyarticlePublishNewUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/publish-new';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('sendNotice' in params) p.query.sendNotice = params.sendNotice;
    ajax.check(params.sendNotice, 'sendNotice');
    p.data = data;
    ajax.check(data, 'body.articleVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 发布文章的接口
   
   * @param data: ParamsBodyarticlePublishUsingPut// articleVO
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articlePublishUsingPut = (
    data: ParamsBodyarticlePublishUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/publish';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.articleVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary updateRedisForArticle
   
   
   * @param opt ajax config
   * @returns {}
   */
  public articleRedisUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/article/redis';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章恢复到上一发布版本
   * @param params ParamsarticleRevertIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articleRevertIdUsingGet = (
    params: ParamsarticleRevertIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/revert/{id}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.id, 'id');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章恢复到上一发布版本
   * @param params ParamsarticleRevertNewBusinessIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articleRevertNewBusinessIdUsingGet = (
    params: ParamsarticleRevertNewBusinessIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/revert-new/{businessId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.businessId, 'businessId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 是保存文章的接口
   
   * @param data: ParamsBodyarticleSaveNewUsingPut// articleVO
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articleSaveNewUsingPut = (
    data: ParamsBodyarticleSaveNewUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/save-new';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.articleVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 是保存文章的接口
   
   * @param data: ParamsBodyarticleSaveUsingPut// articleVO
   * @param opt ajax config
   * @returns models.CommonResultArticleVo
   */
  public articleSaveUsingPut = (
    data: ParamsBodyarticleSaveUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleVo> => {
    const path = '/api/article/save';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.articleVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 获取可以选择的所有圈子或团队
   * @param params ParamsarticleSelectGroupOrTeamUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultGroupOrTeamEntity
   */
  public articleSelectGroupOrTeamUsingGet = (
    params: ParamsarticleSelectGroupOrTeamUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultGroupOrTeamEntity> => {
    const path = '/api/article/select/groupOrTeam';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 文章的数据统计面板
   
   
   * @param opt ajax config
   * @returns models.CommonResultArticleStatisticVO
   */
  public articleStatisticUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultArticleStatisticVO> => {
    const path = '/api/article/statistic';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 是保存文章的接口
   
   
   * @param opt ajax config
   * @returns {}
   */
  public articleTagFixUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/article/tag/fix';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 使用keywords过滤当前用户所有标签 用于文章发布时选择标签
   * @param params ParamsarticleTagsUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public articleTagsUsingGet = (
    params: ParamsarticleTagsUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/article/tags';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('keywords' in params) p.query.keywords = params.keywords;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 是保存文章的接口
   
   
   * @param opt ajax config
   * @returns {}
   */
  public articleTransferUsingGet = (opt?: ExtraFetchParams): AjaxPromise<{}> => {
    const path = '/api/article/transfer';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new ArticleApi();
